import React, {useEffect, useState} from "react";
import {NewResident, H2, Row} from "@reside/ui";
import {useFetchSimilarResidents} from "../../page-admin-residents/hooks/useFetchSimilarResidents";
import {useHandleSimilarResidents} from "../hooks/useHandleSimilarResidents";
import {ListOfPossibleDuplicates} from "./ListOfPossibleDuplicates";
import {BackdropSpinner} from "../../../atoms/spinner";
import {ResidentAdmissionsButtonWithModal} from "../../../atoms/resident-admissions-modal/ResidentAdmissionsButtonWithModal";

export const PossibleDuplicates = ({
  currentUserOrganizationId,
}: {
  currentUserOrganizationId: string;
}): JSX.Element => {
  const {shouldSearchSimilarResidents, similarResidentsSearchData} =
    useHandleSimilarResidents();

  const {
    data: remoteResidents,
    mutate: fetchSimilarResidents,
    isLoading: isFetchingSimilarResidents,
  } = useFetchSimilarResidents();

  const [shouldShowDuplicatesList, setShouldShowDuplicatesList] =
    useState<boolean>(true);

  // Whenever new similar residents are sought for check if window should be shown. It should be shown only when similar residents exist.
  useEffect(() => {
    setShouldShowDuplicatesList(!!remoteResidents?.length);
    // eslint-disable-next-line
  }, [isFetchingSimilarResidents]);

  // Dependencies for search for similar residents.
  const searchDuplicatesDeps = [
    similarResidentsSearchData.first_name,
    similarResidentsSearchData.last_name,
    similarResidentsSearchData.date_of_birth,
    fetchSimilarResidents,
  ];

  useEffect(() => {
    // Whenever conditions are met similar residents will be searched.
    if (shouldSearchSimilarResidents) {
      fetchSimilarResidents({
        ...similarResidentsSearchData,
        organization_id: currentUserOrganizationId,
      });
    }
    // eslint-disable-next-line
  }, searchDuplicatesDeps);

  const duplicateResident = remoteResidents?.find(
    resident => resident.match === "100%",
  );

  const hasDuplicate = !!duplicateResident;

  return (
    <>
      <H2>
        {hasDuplicate ? "Existing Resident Profile" : "New Resident Profile"}
      </H2>
      <NewResident
        formValues={similarResidentsSearchData}
        selectable={false}
        hasSimilarResidents={shouldShowDuplicatesList}
        hasDuplicate={hasDuplicate}
        residentFilesModal={({rowData}: Row) => (
          <ResidentAdmissionsButtonWithModal rowData={rowData} />
        )}
        duplicateResident={duplicateResident}
      />
      <BackdropSpinner active={isFetchingSimilarResidents}>
        <ListOfPossibleDuplicates
          remoteResidents={remoteResidents}
          similarResidentsSearchData={similarResidentsSearchData}
          shouldShowDuplicatesList={shouldShowDuplicatesList}
        />
      </BackdropSpinner>
    </>
  );
};
